export default {"src":"https://fishbrain.com/_next/static/media/activeLinkIcon.d3609999.svg","height":20,"width":6,"blurWidth":0,"blurHeight":0};